import {
	DOC_APPROVED,
	DOC_COMMENTED,
	DOC_COMMENTING,
	DOC_COMMENTING_FAILED,
	DOC_COMMENTING_INITIALIZE,
} from "../actions/types";
const initialState = {
	isCommenting: false,
	isCommented: false,
	isFailed: false,
	id: "",
};
export default function (state = initialState, action) {
	switch (action.type) {
		case DOC_COMMENTING:
			return {
				...state,
				isCommenting: true,
				isCommented: false,
				isFailed: false,
				id: "",
			};
		case DOC_COMMENTED:
			return {
				...state,
				isCommenting: false,
				isCommented: true,
				isFailed: false,
			};
		case DOC_APPROVED:
			return {
				...state,
				isCommenting: false,
				isCommented: true,
				isFailed: false,
				id: action.payload,
			};
		case DOC_COMMENTING_INITIALIZE:
			return {
				...state,
				isCommenting: false,
				isCommented: false,
				isFailed: false,
				id: null,
			};

		case DOC_COMMENTING_FAILED:
			return {
				...state,
				isCommenting: false,
				isCommented: false,
				isFailed: true,
				id: "",
			};

		default:
			return state;
	}
}
